import type { Cart } from '@/modules/cart/domain/Cart';

import type { PriceDto } from '../types/PriceDto';

export const getTotalCost = (cartData: Cart | undefined): PriceDto => {
  if (cartData) {
    const totalPayment = cartData?.lineItems.reduce(
      (acc, curr) => {
        return {
          ...acc,
          centAmount:
            acc.centAmount + curr.price.value.centAmount * curr.quantity
        };
      },
      { centAmount: 0, currencyCode: 'CLP', fractionDigits: 0 }
    );

    return totalPayment as PriceDto;
  }
  return { centAmount: 0, currencyCode: 'CLP', fractionDigits: 0 } as PriceDto;
};
